import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './Pages/App/index.jsx'
import './main.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
